import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects, fetchConfig } from "utils";

const useMyLibrary = (queryParams) => {
	const { accessToken } = useTokenStore();
	const fetch = async () => {
		const instance = await InitApi({ accessToken, apiVersion: "v2" });
		const params = queryParams ? deleteEmptyObjects(queryParams) : null;
		const response = await instance.get("books/my-library", {
			params: { ...params },
		});
		return response.data;
	};
	return useQuery(["purchased", "my-library", queryParams], () => fetch(), {
		...fetchConfig,
	});
};

export default useMyLibrary;
